<div class="trust-income-principal-container" [formGroup]="parentForm">
  <div
    class="row"
    [ngClass]="isWireTransaction ? 'income-principal-column-gap' : ''"
  >
    <div
      [ngClass]="
        !shouldStyleHorizontal
          ? ['col', 'container', 'verticalWidth']
          : isFromAccount
          ? ['col', 'container', 'horizontalWidthFromAccount']
          : ['col', 'container', 'horizontalWidthToAccount']
      "
    >
      <label
        [ngClass]="isTrustIncomePercentInvalid ? 'error-text' : 'label'"
        for="trustIncomePercent"
        >Income
      </label>
      <div
        class="input-container percentInput"
        [ngClass]="isWireTransaction ? 'wire-transaction-width' : ''"
      >
        <input
          class="sdps-input sdps-input--small"
          data-testid="income-percent-input"
          [class.is-invalid]="isTrustIncomePercentInvalid"
          id="{{ trustIncomeControlName }}"
          name="{{ trustIncomeControlName }}"
          type="text"
          formControlName="{{ trustIncomeControlName }}"
          (blur)="formatIncomePercent()"
          (keydown)="
            validationService.validateNumberInput($event, percentAllowedChars)
          "
          (input)="removeExtraDecimalPlaceFromIncome()"
        />
        <i
          *ngIf="trustIncomePercent?.value && !trustIncomePercent?.disabled"
          (click)="clearIncomePercent()"
          class="sch-thin-x"
          data-testid="income-clear-x"
        ></i>
      </div>
    </div>
    <div
      [ngClass]="
        !shouldStyleHorizontal
          ? ['col', 'container', 'verticalWidth']
          : isFromAccount
          ? ['col', 'container', 'horizontalWidthFromAccount']
          : ['col', 'container', 'horizontalWidthToAccount']
      "
    >
      <label
        [ngClass]="isTrustPrincipalPercentInvalid ? 'error-text' : 'label'"
        for="trustIncomePercent"
        >Principal</label
      >
      <div
        class="input-container percentInput"
        [ngClass]="isWireTransaction ? 'wire-transaction-width' : ''"
      >
        <input
          class="sdps-input sdps-input--small"
          data-testid="principal-percent-input"
          [class.is-invalid]="isTrustPrincipalPercentInvalid"
          id="{{ trustPrincipalControlName }}"
          name="{{ trustPrincipalControlName }}"
          type="text"
          formControlName="{{ trustPrincipalControlName }}"
          (blur)="formatPrincipalPercent()"
          (keydown)="
            validationService.validateNumberInput($event, percentAllowedChars)
          "
          (input)="removeExtraDecimalPlaceFromPrincipal()"
        />
        <i
          *ngIf="
            trustPrincipalPercent?.value && !trustPrincipalPercent?.disabled
          "
          (click)="clearPrincipalPercent()"
          class="sch-thin-x"
          data-testid="principal-clear-x"
        ></i>
      </div>
      <span
        id="principalPercentOnlyMessage"
        class="principalPercentOnlyMessage"
        data-testid="principalPercentOnlyMessage"
        *ngIf="piCode === 'P'"
        >{{ principalPercentOnly }}
      </span>
    </div>
  </div>
  <div
    *ngIf="
      (trustIncomePercent?.touched && trustIncomePercent?.value !== '') ||
      (trustPrincipalPercent?.touched && trustPrincipalPercent?.value !== '')
    "
  >
    <div
      class="alert-text"
      id="trustAndSumError"
      data-testid="SumErrorIncomeAndPrincipal"
    >
      {{ trustIncomeAndPrincipalSumError }}
    </div>
  </div>
  <div
    *ngIf="
      (trustIncomePercent?.invalid && trustIncomePercent?.touched) ||
      (trustPrincipalPercent?.invalid && trustPrincipalPercent?.touched)
    "
  >
    <div
      class="alert-text"
      id="trustAndSumError"
      data-testid="trustIncomeAndPrincipalError"
    >
      {{ trustIncomeAndPrincipalError }}
    </div>
  </div>
  <div *ngIf="hasIncomeOverdraftError">
    <div class="alert-text" data-testid="overdraftRulesErrorIncome">
      {{ overdraftRulesError }}
    </div>
  </div>
  <div
    *ngIf="hasPrincipalOverdraftError || hasIncomeAndPrincipalOverdraftError"
  >
    <div class="alert-text" data-testid="overdraftRulesErrorPrincipal">
      {{ overdraftRulesError }}
    </div>
  </div>
</div>
